import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import { LI, UL } from '../../../../../AbstractElements'
import { popularTagsData } from '../../../../../Data/Miscellaneous/Blog'
import CardHeaderSpan from '../../../../../Utils/CommonComponents/CardHeaderSpan'
import { Href, PopularTagsTitle } from '../../../../../Utils/Constants'

export default function PopularTags() {
    return (
        <Col sm={12}>
            <Card>
                <CardHeaderSpan headingClassName='pb-0 border-0' smallHeading={PopularTagsTitle} />
                <CardBody>
                    <UL className="tags">
                        {popularTagsData.map((item, index) => (
                            <LI key={index}>
                                <a href={Href}>{item}</a>
                            </LI>
                        ))}
                    </UL>
                </CardBody>
            </Card>
        </Col>
    )
}